export default {
	title: 'application_settings',
	components: [
		{ title: 'pin_lock', component: 'pin_lock' },
		{ title: 'consumption_calculation', component: 'consumption_calculation' },
	],
};
